export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_b752972b-7d05-44ed-a97a-450308bed7b0/artifacts/r7souxxb_IMG_0181.jpeg";

export const HERO_GRAPHIC =
  "https://static.prod-images.emergentagent.com/jobs/b752972b-7d05-44ed-a97a-450308bed7b0/images/5f3bc04900e58d6105af6645819f073cdcd1640b354941545837609c00a490a8.png";

export const FOUNDER_IMAGE =
  "https://customer-assets.emergentagent.com/job_jt-scales-preview/artifacts/khvdln0u_IMG_5146.JPEG";

export const INSTAGRAM_URL =
  "https://www.instagram.com/jtbrandscalesky?igsh=cWEzamRyZHY3emhs";

export const CONTACT_EMAIL = "jtbrandscales@gmail.com";
export const LOCATION = "Lexington, Kentucky";
export const HOURS = "10am – 7pm, Mon – Sat";

export const NAV_LINKS = [
  { label: "Services", href: "#services", testid: "nav-services" },
  { label: "Pricing", href: "#pricing", testid: "nav-pricing" },
  { label: "Reviews", href: "#reviews", testid: "nav-reviews" },
  { label: "About", href: "#about", testid: "nav-about" },
  { label: "Contact", href: "#contact", testid: "nav-contact" },
];

export const SERVICES = [
  {
    icon: "Target",
    title: "Brand Strategy & Positioning",
    desc: "Sharp messaging, audience clarity and a positioning story that makes your brand impossible to ignore.",
  },
  {
    icon: "Palette",
    title: "Logo & Visual Identity",
    desc: "Memorable, versatile identity systems — logo, palette, type and templates your team can actually use.",
  },
  {
    icon: "Monitor",
    title: "Website Design & Development",
    desc: "Fast, mobile-first sites that convert visitors into inquiries. Built to grow with your business.",
  },
  {
    icon: "Megaphone",
    title: "Digital Marketing & Ads",
    desc: "Targeted campaigns that put your brand in front of the right Kentucky customers — and bring real leads.",
  },
];

export const PRICING = [
  {
    name: "Starter",
    price: "200",
    cadence: "/mo",
    tagline: "Get your first ads in market.",
    features: [
      "Custom ad creative",
      "Local audience targeting",
      "Campaign launch setup",
      "Basic results review",
    ],
    cta: "Start with Starter",
    highlight: false,
    testid: "pricing-starter",
  },
  {
    name: "Growth",
    price: "400",
    cadence: "/mo",
    tagline: "Our most-picked plan.",
    features: [
      "Multiple ad creatives",
      "Advanced audience targeting",
      "Ongoing campaign optimization",
      "Lead generation focus",
    ],
    cta: "Choose Growth",
    highlight: true,
    testid: "pricing-growth",
  },
  {
    name: "Scale",
    price: "750",
    cadence: "/mo",
    tagline: "Full-stack growth partner.",
    features: [
      "Full marketing management",
      "Retargeting campaigns",
      "Face-to-face advertising",
      "Hands-on growth support",
    ],
    cta: "Go Scale",
    highlight: false,
    testid: "pricing-scale",
  },
];

export const TESTIMONIALS = [
  {
    name: "Sarah Johnson",
    role: "Local business owner",
    quote:
      "JT Brand Scaling truly understands the power of branding and has helped my business reach new heights. Dedicated, creative, and always going the extra mile.",
  },
  {
    name: "Marcus R.",
    role: "Founder",
    quote:
      "JT Brand Scales improved our online presence and brought in more customer inquiries within weeks. Very professional and easy to work with.",
  },
  {
    name: "Ashley P.",
    role: "Owner",
    quote:
      "Great experience from start to finish. They gave our business a fresh look, stronger branding and clearer marketing direction.",
  },
  {
    name: "David K.",
    role: "Operations Lead",
    quote:
      "They went above and beyond. Communication was great, the ideas were creative, and everything was handled professionally. Five stars all the way.",
  },
  {
    name: "Priya S.",
    role: "Co-founder",
    quote:
      "If you need help growing your business online, this is the team to call. They made the process simple and delivered real value.",
  },
  {
    name: "Tom W.",
    role: "Director",
    quote:
      "Excellent service and great attention to detail. They took the time to understand our goals and built a strategy that fit our business perfectly.",
  },
  {
    name: "Renee M.",
    role: "Restaurant owner",
    quote:
      "We noticed more traffic, more engagement and better overall branding after working with JT Brand Scales. They really care about client success.",
  },
  {
    name: "Carlos G.",
    role: "Service business",
    quote:
      "Very impressed with the professionalism and quality of work. Quick to respond and delivered exactly what we needed.",
  },
  {
    name: "Lena B.",
    role: "Boutique owner",
    quote:
      "JT helped us stand out in a competitive market. Their marketing ideas were smart, effective and tailored to our business.",
  },
  {
    name: "Devon H.",
    role: "Contractor",
    quote:
      "Working with JT Brand Scales was one of the best decisions we made. Fresh energy, new ideas, and more customers walking in.",
  },
];

export const STATS = [
  { value: "50+", label: "Kentucky brands launched" },
  { value: "4.9★", label: "Average client rating" },
  { value: "3x", label: "Avg. lead growth in 90 days" },
  { value: "24h", label: "Response time" },
];
